<template>
  <div class="container has-text-left">
    <div class="block">
      <div class="container has-text-left">
        <h5 class="title is-5">Run command</h5>
        <div class="level">
          <div class="level-left">
            <div class="level-item">Message:</div>
            <div class="level-item">
              <b-input required v-model="message"/>
            </div>
          </div>
        </div>

        <div class="level">
          <div class="level-left">
            <div class="level-item">Delay:</div>
            <div class="level-item">
              <b-select v-model="delay">
                <option v-for="optDelay in delayOptions"
                        :key="optDelay.id"
                        :value="optDelay.id"
                >{{optDelay.name}}
                </option>
              </b-select>
            </div>
          </div>
        </div>

        <div class="buttons">
          <b-button type="is-success" @click="handleRunCommandOnObject">Run</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import BButton from "buefy/src/components/button/Button";
  import BSelect from "buefy/src/components/select/Select";

  export default {
    components: {
      BSelect,
      BButton,
    },
    name: "run-command-on-object",
    props: ['id', 'endpointId'],
    data() {
      return {
        delay: 0,
        message: '0'
      };
    },
    computed: {
      ...mapGetters('objects', ['groupById', 'objects', 'objectTypes', 'objectsByObjectType', 'objectById']),
      ...mapGetters('notifications', ['notificationHandlers']),
      ...mapGetters('automations', ['eventEvaluationTemplates', 'conditionOperators', 'scheduleRepeatTemplates', 'scheduleRepeatTemplateById', 'automationsAvailableForRun', 'automationById']),
      ...mapGetters('auth', ['userList', 'userData']),
      delayOptions() {
        const ret = [
          {
            id: 0,
            name: 'now'
          },
          {
            id: 30,
            name: '30 sec'
          }
        ];

        for (let i = 1;i<=15;i+=1) {
          const delayInSeconds = i * 60;
          ret.push({
            id: delayInSeconds,
            name: `${i} min`
          });
        }

        return ret;
      }
    },
    methods: {
      ...mapActions('objects', ['runCommandOnObject']),
      handleRunCommandOnObject() {
        this.runCommandOnObject({
          id: this.object.name,
          message: this.message,
          delay: this.delay,
          cb: () => {

          }
        });
      }
    },
    created() {
      this.object = this.objectById(this.id);
    },
    mounted() {
    }
  }
</script>

<style scoped>

</style>
